/**
 * Whether an attachment should go through async Textract (doc_processor).
 * Plain text types are read directly in agent.py from S3.
 */
export function attachmentNeedsTextract(contentType) {
  const c = String(contentType || '').toLowerCase();
  if (!c) return true;
  if (c.includes('pdf')) return true;
  if (c.startsWith('image/')) return true;
  if (c.includes('msword') || c.includes('wordprocessingml') || c.includes('spreadsheetml')) return true;
  if (c.startsWith('text/')) return false;
  return true;
}
